import { MouseEventHandler } from 'react';

export const Button = ({
  description,
  icon,
  backgroundColor,
  textColor,
  fontSize,
  fontWeight,
  heigh,
  border,
  width,
  handleClick,
  className,
  borderColor,
  isDisabled = false,
  iconClass,
  borderSize,
  iconDirection,
  full,
  descriptionClass,
  removeDefaultSpaces,
  overlap
}: {
  description: string;
  icon?: string;
  backgroundColor: string;
  textColor: string;
  fontSize: number;
  fontWeight: number;
  heigh: number;
  border: number;
  width?: number;
  handleClick?: MouseEventHandler<HTMLButtonElement>;
  className?: string;
  borderColor?: string;
  isDisabled?: boolean;
  iconClass?: string;
  borderSize?: string;
  iconDirection?: string;
  full?: boolean;
  descriptionClass?: string;
  removeDefaultSpaces?: boolean;
  overlap?: boolean;
}) => {
  return (
    <>
      <button
        onClick={handleClick}
        disabled={isDisabled}
        className={`${removeDefaultSpaces ? '' : 'px-4'} inline-flex items-center ${
          heigh === 0 ? '' : ''
        } rounded-[${border}px] cursor-pointer flex justify-center ${
          className ? (className.includes('mr-') ? className : `${className} mr-1`) : 'mr-1'
        } ${
          isDisabled
            ? description === 'Cancel'
              ? 'opacity-25 cursor-not-allowed'
              : 'opacity-60 cursor-not-allowed'
            : ''
        } outline-none ${overlap ? 'z-[1000]' : ''} `}
        style={{
          backgroundColor: backgroundColor,
          width: width ? width : full ? '100%' : 'auto',
          border: `${borderSize ? borderSize : '1px'} solid ${borderColor}`,
          height: heigh === 0 ? '' : heigh,
          borderRadius: border
        }}>
        {icon && (!iconDirection || iconDirection == 'left') ? (
          <img
            src={`/icons/${icon}`}
            alt={`icon-/${icon}`}
            className={`${iconClass} mr-2 fill-[#243c5a]`}
          />
        ) : null}
        <span
          className={`${icon ? 'mr-1' : ''} ${
            iconDirection == 'right' ? 'ml-4' : ''
          } font-montserrat ${descriptionClass}`}
          style={{ fontSize: fontSize, fontWeight: fontWeight, color: textColor }}>
          {description}
        </span>

        {icon && iconDirection == 'right' ? (
          <img src={icon} alt="icon" className={`${iconClass} mr-2 fill-[#243c5a] -ml-1`} />
        ) : (
          <></>
        )}
      </button>
    </>
  );
};
